'use strict';

angular.module('TurneroApp').component('coTurnosfiltro', {
    bindings: {
        centroAtencionSeleccionadoBinding: '<'
    },
    controller: [
        'turnosService',
        'agendaService',
        'tramiteService',
        'centrosAtencionService',
        '$anchorScroll',
        '$sessionStorage',
        '$rootScope',
        'utilsService',
        '$element',
        '$scope',
        '$timeout',
        function (turnosService, agendaService, tramiteService, centrosAtencionService, $anchorScroll, $sessionStorage, $rootScope, utilsService, $element, $scope, $timeout) {
            var ctrl = this;
            //esta variable se usa para mantener sincronía entre las consultas de los combos
            ctrl.promise = null;

            ctrl.searchTerm = {
                text: ''
            };

            ctrl.paginationOptions = {
                id_Centro_Atencion: ctrl.centroAtencionSeleccionadoBinding ? ctrl.centroAtencionSeleccionadoBinding.id : null
            };

            ctrl.$onChanges = function () {
                ctrl.centroatencionChanges();
                ctrl.filtrosLoad();
            };

            ctrl.clearSearchTerm = function () {
                ctrl.searchTerm = {
                    text: ''
                };
            };

            ctrl.setminVal = function () {
                //ctrl.Fec_Desde = moment(ctrl.Filtro.Fec_Desde).toDate();
                //La propiedada md-min-date hace funcionar mal al calendario si se bindea a un moment
                ctrl.Fec_Desde = moment.isMoment(ctrl.Filtro.Fec_Desde) ? ctrl.Filtro.Fec_Desde.toDate() : ctrl.Filtro.Fec_Desde;
                ctrl.Fecha_Hasta_Limite = moment(ctrl.Filtro.Fec_Desde).add(15, 'day').toDate();
            }

            ctrl.centroatencionChanges = function () {
                if (ctrl.centroAtencionSeleccionadoBinding) {
                    ctrl.centroAtencionSeleccionado = ctrl.centroAtencionSeleccionadoBinding;
                }
                else if (ctrl.Filtro && ctrl.Filtro.Data && ctrl.Filtro.Data.centroAtencion && ctrl.Filtro.Data.centroAtencion.id > 0) {
                    ctrl.centroAtencionSeleccionado = ctrl.Filtro.Data.centroAtencion;
                }
                else {
                    ctrl.centroAtencionSeleccionado = null;
                }

                ctrl.N_CentroAtencion = ctrl.centroAtencionSeleccionado ? ctrl.centroAtencionSeleccionado.text : null;

                ctrl.paginationOptions = {
                    id_Centro_Atencion: ctrl.centroAtencionSeleccionado ? ctrl.centroAtencionSeleccionado.id : null
                };
            }

            ctrl.actualizarFiltrosXCentro = function () {
                ctrl.centroatencionChanges();
                ctrl.filtrarTramites();
                ctrl.filtrarAgendas();
            }

            ctrl.cargaSincrona = function (callback) {
                //Valido la sincronía de las llamadas
                //Esta validación se hace para que no pise los filtros una consulta que se haya iniciado anteriormente pero que se resuelva luego.
                //$$state.status = 0 -> Pending
                //$$state.status = 1 -> Resolved
                //$$state.status = 2 -> Rejected
                if (ctrl.promise && ctrl.promise.$$state.status == 0) {
                    ctrl.promise.finally(function () {
                        callback();
                    });
                }
                else {
                    callback();
                }
            }

            ctrl.filtrosLoad = function () {
                ctrl.atencionEnCursoConsulta = true;

                ctrl.cargaSincrona(ctrl.getFiltro);
            };

            ctrl.getFiltro = function () {
                ctrl.promise = turnosService.Get_Supervision_Filtro({
                    'id_Centro_Atencion': ctrl.centroAtencionSeleccionado ? ctrl.centroAtencionSeleccionado.id : null,
                }).$promise.then(function (data) {
                    ctrl.Filtro = data;
                    ctrl.Filtro.Fec_Desde = moment();
                    ctrl.Filtro.Fec_Hasta = moment();
                    ctrl.Filtro.Data.Mostrar_Turnos_Con_Comentarios = 'N';
                    ctrl.setminVal();
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.filtrarTramites = function () {
                if (!ctrl.paginationOptions.id_Centro_Atencion) {
                    ctrl.cargaSincrona(ctrl.filtrarCentros);
                }

                ctrl.cargaSincrona(ctrl.getTramites);
            };

            ctrl.getTramites = function () {
                var idAgenda = ctrl.Filtro ? ctrl.Filtro.Data.Id_Agenda : null;

                ctrl.promise = tramiteService.Get_X_Agenda({
                    'id_centro_atencion': ctrl.paginationOptions.id_Centro_Atencion,
                    'id_agenda': idAgenda
                }).$promise.then(function (data) {
                    ctrl.Filtro.Data.Tramites = data.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.filtrarAgendas = function () {
                if (!ctrl.paginationOptions.id_Centro_Atencion) {
                    ctrl.cargaSincrona(ctrl.filtrarCentros);
                }

                ctrl.cargaSincrona(ctrl.getAgendas)
            };

            ctrl.getAgendas = function () {
                var idTramite = ctrl.Filtro ? ctrl.Filtro.Data.Id_Tramite : null;

                ctrl.promise = agendaService.get_X_Tramite({
                    'id_centro_atencion': ctrl.paginationOptions.id_Centro_Atencion,
                    'id_tramite': idTramite
                }).$promise.then(function (data) {
                    ctrl.Filtro.Data.Agendas = data.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.filtrarCentros = function () {
                var tramite = ctrl.Filtro && ctrl.Filtro.Data && ctrl.Filtro.Data.Id_Tramite ? ctrl.Filtro.Data.Id_Tramite : ' ';
                var agenda = ctrl.Filtro && ctrl.Filtro.Data && ctrl.Filtro.Data.Id_Agenda ? ctrl.Filtro.Data.Id_Agenda : ' ';

                ctrl.promise = centrosAtencionService.Get_Combo_Centros_Atencion({
                    'Id_Tramite_Relevado': tramite,
                    'Id_Agenda': agenda
                }).$promise.then(function (data) {
                    ctrl.Filtro.Data.Centros_Atencion = data.Data;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            };

            ctrl.aplicarfiltros = function () {
                if (ctrl.Filtro && ctrl.Filtro.Data && ctrl.Filtro.Data.Identificador_Persona) {
                    ctrl.Filtro.Data.Identificador_Persona = utilsService.getNumbersInString(ctrl.Filtro.Data.Identificador_Persona);
                }
                //se transforma la fecha a  MM/DD/YYYY porque el datepicker pasa el dia como si fuera el mes
                //ctrl.Filtro.Data.Fec_Desde = ctrl.Filtro.Fec_Desde ? moment(ctrl.Filtro.Fec_Desde).format('MM/DD/YYYY') : moment().locale('es').format('MM/DD/YYYY')
                //ctrl.Filtro.Data.Fec_Hasta = ctrl.Filtro.Fec_Hasta ? moment(ctrl.Filtro.Fec_Hasta).format('MM/DD/YYYY') : moment().locale('es').format('MM/DD/YYYY')

                //Se necesita convertir a moment dado que al editarse la fecha, el componente mdDatepicker escribe un JS Date aunque haya sido inicializado con objetos moment
                //Enviamos en formato simil JSON/ISO8601 para que sea parseado en el backend con cualquier configuración regional y con la hora Desde/Hasta local al server
                ctrl.Filtro.Data.Fec_Desde = ctrl.Filtro.Fec_Desde ? moment(ctrl.Filtro.Fec_Desde).format('YYYY-MM-DDT00:00:00') : moment().format('YYYY-MM-DDT00:00:00');
                ctrl.Filtro.Data.Fec_Hasta = ctrl.Filtro.Fec_Hasta ? moment(ctrl.Filtro.Fec_Hasta).format('YYYY-MM-DDT23:59:59') : moment().format('YYYY-MM-DDT23:59:59');
                $rootScope.$broadcast('aplicarFiltros', ctrl.Filtro.Data);
                //$scope.$apply();
            };

            ctrl.buscarIdTurno = function () {
                $rootScope.$broadcast('buscarPorId', ctrl.Filtro.Data);
            };

            ctrl.limpiarResultados = function () {
                $rootScope.$broadcast('limpiarResultados', null);

                return null;
            }

            $element.find('input').on('keydown', function (ev) {
                ctrl.searchTerm = ctrl.searchTerm
                ev.stopPropagation();
            });
            $timeout(function () {
                // anything you want can go here and will safely be run on the next digest.
                $scope.$apply();
            })
        }
    ],
    template: require('./turnosFiltros.html')
});



// WEBPACK FOOTER //
// ./app/components/turnos/turnosFiltrosComponent.js